export const getFilteredOptions = ({ options, twoLayerOptions, inputValue, minCharacters, value }) => {
  let selectedOptions = [];
  let filteredOptions = [];
  let filteredTwoLayerOptions = {};
  const isArray = Array.isArray(options) && options.length;
  const loweredInput = inputValue?.toLowerCase() || '';

  if (isArray) {
    // Single-layer option filtering
    filteredOptions = (() => {
      if (!inputValue && minCharacters === 0) {
        return options;
      }
      if (!inputValue || inputValue.length <= minCharacters) {
        return options?.filter((option) => value.includes(option?.value));
      }
      return options?.filter((option) => option?.label.toLowerCase().includes(loweredInput));
    })();

    selectedOptions = options.filter(({ value: option }) => value.includes(option));
  } else {
    Object.entries(twoLayerOptions).forEach(([title, childOptions]) => {
      childOptions.forEach((option) => {
        // Check if the option is selected
        if (value.includes(option?.value)) {
          selectedOptions.push(option);
        }
        // Filter options based on input value
        const lowerTitle = title.toLowerCase();
        const lowerOption = option?.label.toLowerCase();

        if (inputValue && (lowerTitle.includes(loweredInput) || lowerOption.includes(loweredInput))) {
          filteredTwoLayerOptions = { ...filteredTwoLayerOptions, [title]: childOptions };
        }

        if (!inputValue) {
          filteredTwoLayerOptions = { ...twoLayerOptions };
        }
      });
    });
  }

  return {
    selectedOptions,
    filteredOptions,
    filteredTwoLayerOptions
  };
};
